import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    PhoneCall,
    SupportActivity,
} from '@myrtls/api-interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import {
    catchError,
    filter,
    map,
    switchMap,
    withLatestFrom,
} from 'rxjs/operators';
import {
    ACTIVITIES_ENDPOINT,
    PHONE_CALL_ENDPOINT,
    SITES_API_URL,
} from '../../shared/utils/constants';
import { AppState } from '../index';
import { $selectedSiteId } from '../sites/sites.selectors';
import { of } from 'rxjs';
import {
    getPhoneCallFailureAction,
    getPhoneCallRequestAction,
    getPhoneCallSuccessAction,
    getSiteActivitiesFailureAction,
    getSiteActivitiesRequestAction,
    getSiteActivitiesSuccessAction,
} from './support.actions';

@Injectable()
export class SupportEffects {
    getSiteActivities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getSiteActivitiesRequestAction),
            withLatestFrom(
                this.store.pipe(
                    select($selectedSiteId),
                    filter((id): id is string => id != null),
                ),
            ),
            switchMap(([, siteId]) => {
                return this.http
                    .get<
                        SupportActivity[]
                    >(`${SITES_API_URL}/${siteId}/${ACTIVITIES_ENDPOINT}`)
                    .pipe(
                        map(activities =>
                            getSiteActivitiesSuccessAction({
                                activities,
                            }),
                        ),
                        catchError(error =>
                            of(
                                getSiteActivitiesFailureAction({
                                    error,
                                }),
                            ),
                        ),
                    );
            }),
        ),
    );

    getPhoneCall$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getPhoneCallRequestAction),
            withLatestFrom(
                this.store.pipe(
                    select($selectedSiteId),
                    filter((id): id is string => id != null),
                ),
            ),
            switchMap(([, siteId]) =>
                this.http
                    .get<PhoneCall>(
                        `${SITES_API_URL}/${siteId}/${PHONE_CALL_ENDPOINT}`,
                    )
                    .pipe(
                        map(phoneCall =>
                            getPhoneCallSuccessAction({ phoneCall }),
                        ),
                        catchError(error =>
                            of(getPhoneCallFailureAction({ error })),
                        ),
                    ),
            ),
        ),
    );

    constructor(
        private readonly actions$: Actions,
        private readonly store: Store<AppState>,
        private readonly http: HttpClient,
    ) {}
}
